import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { MoneyTransaction } from '@zero/shared/util-models';
import { moneyTransactionsActions, moneyTransactionsApiActions } from './money-transactions.actions';

export const moneyTransactionsAdapter = createEntityAdapter<MoneyTransaction>({
  selectId: (moneyTransaction) => moneyTransaction.id,
  sortComparer: (a, b) => new Date(b.createdDateTime).getTime() - new Date(a.createdDateTime).getTime(),
});

export interface MoneyTransactionsState extends EntityState<MoneyTransaction> {
  loading: boolean;
  initiallyLoaded: boolean;
  page: number;
  hasNext: boolean;
}

export const moneyTransactionInitialState = moneyTransactionsAdapter.getInitialState({
  loading: false,
  initiallyLoaded: false,
  page: 0,
  hasNext: false,
});

export const moneyTransactionsFeature = createFeature({
  name: 'moneyTransactions',
  reducer: createReducer(
    moneyTransactionInitialState,
    on(
      moneyTransactionsActions.incrementMoneyTransactionsPage,
      (state): MoneyTransactionsState => ({
        ...state,
        page: state.page + 1,
      }),
    ),
    on(
      moneyTransactionsActions.resetMoneyTransactions,
      (state): MoneyTransactionsState => ({
        ...state,
        page: 0,
        hasNext: false,
        loading: false,
        initiallyLoaded: false,
      }),
    ),
    on(
      moneyTransactionsActions.incrementMoneyTransactionsPage,
      moneyTransactionsActions.resetMoneyTransactions,
      moneyTransactionsApiActions.loadMoneyTransactionsFromApi,
      (state): MoneyTransactionsState => ({
        ...state,
        loading: true,
      }),
    ),
    on(moneyTransactionsApiActions.loadMoneyTransactionsSuccess, (state, { moneyTransactions, hasNext }): MoneyTransactionsState => {
      return moneyTransactionsAdapter.addMany(moneyTransactions, {
        ...state,
        loading: false,
        initiallyLoaded: true,
        hasNext,
      });
    }),
    on(
      moneyTransactionsApiActions.loadMoneyTransactionsFailure,
      (state): MoneyTransactionsState => ({
        ...state,
        loading: false,
      }),
    ),
  ),
  extraSelectors: ({ selectMoneyTransactionsState }) => ({
    ...moneyTransactionsAdapter.getSelectors(selectMoneyTransactionsState),
  }),
});
